(ns teamoesterreich.user-mode.landing.app-panel.wanahelp-card
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.check :refer [check]]
    [reagent-material-ui.icons.close :refer [close]]
    [reagent-material-ui.icons.close :refer [close]]
    [reagent-material-ui.icons.warning :refer [warning]]

    [reagent.core :as r]
    [teamoesterreich.firebase.remote-config :as remote-config]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]

    ))




(defn cat-warning [!wanado-warnings]
  ;:cat-text :cat-level
  (if (and (:kat-level @!wanado-warnings) (> (:kat-level @!wanado-warnings) 0))
    [:div {:class "helping-warn"
           :title (or (:kat-text @!wanado-warnings) "")}
     [warning {:style {:color (case (:kat-level @!wanado-warnings)
                                2 "#ff3737"
                                "orange")}}]
     [:span (or (:kat-text @!wanado-warnings) "")]
     ]
    ))

(defn nocat-warning [!wanado-warnings]
  ;:cat-text :cat-level
  (if (and (:nokat-level @!wanado-warnings) (> (:nokat-level @!wanado-warnings) 0))
    [:div {:class "helping-warn"
           :title (or (:nokat-text @!wanado-warnings) "")}
     [warning {:style {
                       :color (case (:nokat-level @!wanado-warnings)
                                2 "#ff3737"
                                "orange")}}]
     [:span (or (:nokat-level @!wanado-warnings) "")]
     ]
    ))


(defn online-warning [!wanado-warnings]
  ;:cat-text :cat-level
  (if (and (:online-level @!wanado-warnings) (> (:online-level @!wanado-warnings) 0))
    [:div {:class "helping-warn"
           :title (or (:online-text @!wanado-warnings) "")}
     [warning {:style {
                       :color (case (:online-level @!wanado-warnings)
                                2 "#ff3737"
                                "orange")}}]
     [:span (or (:online-text @!wanado-warnings) "")]
     ]
    ))

(defn lr-warning [!wanado-warnings]
  ;:cat-text :cat-level
  (if (and (:lebensretter-level @!wanado-warnings) (> (:lebensretter-level @!wanado-warnings) 0))
    [:div {:class "helping-warn"
           :title (or (:lebensretter-text @!wanado-warnings) "")}
     [warning {:style {
                       :color (case (:lebensretter-level @!wanado-warnings)
                                2 "#ff3737"
                                "orange")}}]
     [:span (or (:lebensretter-text @!wanado-warnings) "")]
     ]
    ))

(defn tafel-warning [!wanado-warnings]
  ;:cat-text :cat-level
  (if (and (:tafel-level @!wanado-warnings) (> (:tafel-level @!wanado-warnings) 0))
    [:div {:class "helping-warn"
           :title (or (:tafel-text @!wanado-warnings) "")}
     [warning {:style {
                       :color (case (:tafel-level @!wanado-warnings)
                                2 "#ff3737"
                                "orange")}}]
     [:span (or (:tafel-text @!wanado-warnings) "")]
     ]
    ))

(defn neighbor-warning [!wanado-warnings]
  ;:cat-text :cat-level
  (if (and (:neighbor-level @!wanado-warnings) (> (:neighbor-level @!wanado-warnings) 0))
    [:div {:class "helping-warn"
           :title (or (:neighbor-text @!wanado-warnings) "")}
     [warning {:style {
                       :color (case (:neighbor-level @!wanado-warnings)
                                2 "#ff3737"
                                "orange")}}]
     [:span (or (:neighbor-text @!wanado-warnings) "")]
     ]
    ))



(defn is-online [!actual-user !locations]
  (let [
        !request-kat (r/cursor store/app-state [:actual-user :request-catastrophy])
        !status-kat (r/cursor store/app-state [:actual-user :status-catastrophy])
        !request-nokat (r/cursor store/app-state [:actual-user :request-nokat])
        !status-nokat (r/cursor store/app-state [:actual-user :status-nokat])
        !request-online (r/cursor store/app-state [:actual-user :request-online])
        !status-online (r/cursor store/app-state [:actual-user :status-online])
        !request-lebensretter (r/cursor store/app-state [:actual-user :request-lebensretter])
        !status-lebensretter (r/cursor store/app-state [:actual-user :status-lebensretter])
        !request-tafel (r/cursor store/app-state [:actual-user :request-tafel])
        !status-tafel (r/cursor store/app-state [:actual-user :status-tafel])
        !request-neighbor (r/cursor store/app-state [:actual-user :request-neighbor])
        !status-neighbor (r/cursor store/app-state [:actual-user :status-neighbor])
        !wanado-warnings (r/cursor store/app-state [:actual-user :wanado-warnings])
        ]
    [mui/paper {:class   "app-panel clickable"
                :style   {:textAlign "left" :cursor "hand"}
                :onClick #(a/set-page :wanaHelp)
                }
     [:div {:class "app-panel-img"}
      [:img {:src "/custom/img/helfen_bunt.png" :alt "t-man"}]
      ]
     [:div {:class "app-panel-content"}
      [:div {:class "app-panel-title"}
       (txt/transl "Ich helfe mit")]

      (when (remote-config/get-boolean "help_card_emergency")
        [:div {:class "helping-row"}
         [:div {:class "helping-icon"}
          (if (and @!request-kat @!status-kat)
            [check {:fontSize "small"}]
            [close {:fontSize "small" :style {:color "#666"}}])]
         [:div {:class "helping-text"}
          (txt/transl "Ich helfe im Katastrophenfall")]
         (when @!request-kat (cat-warning !wanado-warnings))
         ])

      (when (remote-config/get-boolean "help_card_no_emergency")
        [:div {:class "helping-row"}
         [:div {:class "helping-icon"}
          (if (and @!request-nokat @!status-nokat)
            [check {:fontSize "small"}]
            [close {:fontSize "small" :style {:color "#666"}}])]
         [:div {:class "helping-text"}
          (txt/transl "Ich helfe ohne Katastrophe")]
         (when @!request-nokat (nocat-warning !wanado-warnings))
         ])

      (when (remote-config/get-boolean "help_card_lebensretter")
        [:div {:class "helping-row"}
         [:div {:class "helping-icon"}
          (if (and @!request-lebensretter @!status-lebensretter)
            [check {:fontSize "small"}]
            [close {:fontSize "small" :style {:color "#666"}}])]
         [:div {:class "helping-text"
                }
          (txt/transl "Ich bin Lebensretter ")]
         (when @!request-lebensretter (lr-warning !wanado-warnings))
         ])

      (when (remote-config/get-boolean "help_card_online")
        [:div {:class "helping-row"}
         [:div {:class "helping-icon"}
          (if (and @!request-online @!status-online)
            [check {:fontSize "small"}]
            [close {:fontSize "small" :style {:color "#666"}}])]
         [:div {:class "helping-text"}
          (txt/transl "Ich helfe online")]
         (when @!request-online (online-warning !wanado-warnings))
         ])
      (when (remote-config/get-boolean "help_card_tafel")
        [:div {:class "helping-row"}
         [:div {:class "helping-icon"}
          (if (and @!request-tafel @!status-tafel)
            [check {:fontSize "small"}]
            [close {:fontSize "small" :style {:color "#666"}}])]
         [:div {:class "helping-text"
                }
          (txt/transl "Ich bin Tafel-Helfer ")]
         (when @!request-tafel (tafel-warning !wanado-warnings))
         ])

      (when (remote-config/get-boolean "help_card_neighbourhood")
        [:div {:class "helping-row"}
         [:div {:class "helping-icon"}
          (if (and @!request-neighbor @!status-neighbor)
            [check {:fontSize "small"}]
            [close {:fontSize "small" :style {:color "#666"}}])]
         [:div {:class "helping-text"
                }
          (txt/transl "Ich bin Nachbarschaftshelfer ")]
         (when @!request-neighbor (neighbor-warning !wanado-warnings))
         ])

      [:br]
      ]
     ]))

(defn login []
  [mui/paper {:class   "app-panel clickable"
              :style   {:textAlign "left" :cursor "hand"}
              :onClick #(a/set-page :wanaHelp)
              }
   [:div {:class "app-panel-img"}
    [:img {:src "/custom/img/helfen_bunt.png" :alt "t-man"}]
    ]
   [:div {:class "app-panel-content"}
    [:div {:class "app-panel-title"} (txt/transl "Ich helfe mit ....")]
    ]

   ])

(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        !locations (r/cursor store/app-state [:locations])]
    (if (:tom-id @!actual-user)
      (is-online !actual-user !locations)
      (login)
      )))
